export const createArtificialId = () => {
  return Math.round(Math.random() * 9999999) + 1;
};

export const createArtificialIdAlfanumerico = () => {
  const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let idMock = '';

  for (let i = 0; i < 32; i++) {
    const indiceRandom = Math.floor(Math.random() * caracteres.length);
    idMock += caracteres.charAt(indiceRandom);
  }

  return idMock;
};
